var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes_button,attrs:{"type":"button","title":_vm.title,"disabled":_vm.disabled},on:{"click":_vm.clickButton}},[_c('div',{class:_vm.classes_text},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('button-loader',{attrs:{"show":_vm.spinner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }